import Vue from 'vue'

export default {
    namespaced: true,
    state: {
        theme: 1,
        fontTheme: 3,
        windowWidth: window.innerWidth
    },
    getters: {
        appColorTheme: (state) => {
            switch (state.theme) {
                case 2:
                    return 'theme-dark'
                default:
                    return ''
            }
        },
        layoutType: (state) => state.windowWidth >= 1200 ? 'desktop' : 'tablet'
    },
    mutations: {
        setColorTheme(state, data) {
            Vue.$cookies.set('theme', data);
            state.theme = +data;
        },
        setFontTheme(state, data) {
            const fontSize = data => {
                switch (data) {
                    case 1:
                        return 8
                    case 2:
                        return 9
                    case 3:
                        return 10
                    case 4:
                        return 11
                    case 5:
                        return 12
                    default:
                        return 10
                }
            };
            document.documentElement.style.fontSize = `${fontSize(+data)}px`;
            Vue.$cookies.set('fontTheme', data);
            state.fontTheme = +data;
        },
        setWindowWidth(state, width) {
            state.windowWidth = width
        }
    }
}